var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16669 0.333496H12.8334C13.0635 0.333496 13.25 0.520044 13.25 0.750163C13.25 0.840317 13.2208 0.928039 13.1667 1.00016L8.66669 7.00016V13.826C8.66669 14.0561 8.48014 14.2426 8.25002 14.2426C8.18534 14.2426 8.12154 14.2276 8.06368 14.1987L5.33336 12.8335V7.00016L0.833358 1.00016C0.695287 0.816068 0.732596 0.554901 0.916691 0.416829C0.988815 0.362737 1.07654 0.333496 1.16669 0.333496Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.ee84e66f0fb4afd6a3f1fc8c8b74a5fe.svg";
export { ForwardRef as ReactComponent };